(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nadi-guard-line"] && !Shopify.designMode) return;
  try {
    
  /* ----------------------------------------------------------------
     NADI — Guard line waitlist
     Reveals an email capture and subscribes the address to a Klaviyo
     list through Klaviyo's public CLIENT subscription endpoint. Email
     is the only field. Nothing is autofilled and the address never
     enters a URL. All copy and ids arrive as data-attributes because
     this file is static and shared by every instance.
     ---------------------------------------------------------------- */
  class NadiWaitlist extends HTMLElement {
    connectedCallback() {
      this.companyId = this.dataset.companyId;
      this.listId = this.dataset.listId;
      this.source = this.dataset.source || 'Guard line waitlist';

      this.trigger = this.querySelector('[data-waitlist-trigger]');
      this.panel = this.querySelector('[data-waitlist-panel]');
      this.form = this.querySelector('[data-waitlist-form]');
      this.input = this.querySelector('[data-waitlist-input]');
      this.submit = this.querySelector('[data-waitlist-submit]');
      this.status = this.querySelector('[data-waitlist-status]');

      if (this.trigger) {
        this.trigger.addEventListener('click', () => this.toggle());
      }
      if (this.form) {
        this.form.addEventListener('submit', (e) => this.onSubmit(e));
      }
    }

    toggle() {
      if (!this.panel) return;
      const willOpen = this.panel.hidden;
      this.panel.hidden = !willOpen;
      this.trigger.setAttribute('aria-expanded', String(willOpen));
      if (willOpen && this.input) this.input.focus();
    }

    setStatus(message, state) {
      if (!this.status) return;
      this.status.textContent = message || '';
      this.status.setAttribute('data-state', state || '');
    }

    async onSubmit(event) {
      event.preventDefault();
      if (!this.input || !this.input.checkValidity()) {
        if (this.input) this.input.reportValidity();
        return;
      }
      if (!this.companyId || !this.listId) {
        this.setStatus(this.dataset.errorText, 'error');
        return;
      }

      const email = this.input.value.trim();
      if (this.submit) this.submit.disabled = true;
      this.setStatus(this.dataset.pendingText, 'pending');

      const payload = {
        data: {
          type: 'subscription',
          attributes: {
            profile: { data: { type: 'profile', attributes: { email: email } } },
            custom_source: this.source,
          },
          relationships: { list: { data: { type: 'list', id: this.listId } } },
        },
      };

      try {
        const response = await fetch(
          'https://a.klaviyo.com/client/subscriptions/?company_id=' + encodeURIComponent(this.companyId),
          {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', revision: '2024-10-15' },
            body: JSON.stringify(payload),
          }
        );

        if (response.ok || response.status === 202) {
          this.form.reset();
          if (this.input) this.input.hidden = true;
          if (this.submit) this.submit.hidden = true;
          this.setStatus(this.dataset.successText, 'success');
        } else {
          if (this.submit) this.submit.disabled = false;
          this.setStatus(this.dataset.errorText, 'error');
        }
      } catch (error) {
        if (this.submit) this.submit.disabled = false;
        this.setStatus(this.dataset.errorText, 'error');
      }
    }
  }

  if (!customElements.get('nadi-waitlist')) {
    customElements.define('nadi-waitlist', NadiWaitlist);
  }

  } catch(e) { console.error(e); }
})();
})();
